module.exports = __webpack_public_path__ + "img/complete.e3258a2c.png";